import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const isSelected = (question, answers, value) => question.type === "multi"
  ? (answers[question.id] || []).includes(value) : answers[question.id] === value;

export const QuestionChoices = ({ question, answers, setAnswer, toggleMulti }) => {
  const chooseOption = question.type === "multi" ? toggleMulti : setAnswer;
  return (
    <div className="mt-6 grid gap-3 sm:grid-cols-2">
      {question.options.map((option) => {
        const selected = isSelected(question, answers, option.value);
        return (
          <button key={option.value} type="button" data-testid={`q-option-${option.value}`}
            aria-pressed={selected} onClick={() => chooseOption(question.id, option.value)}
            className={cn("flex items-start gap-3 rounded-xl border p-4 text-left transition-[border-color,background-color] duration-200",
              selected ? "border-blue-600 bg-blue-100 ring-2 ring-blue-200" : "border-border bg-white hover:border-slate-300")}>
            <span className={cn("mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center border",
              question.type === "multi" ? "rounded-md" : "rounded-full",
              selected ? "border-blue-600 bg-blue-100 text-white" : "border-slate-300")}>
              {selected && <Check className="h-3.5 w-3.5" />}
            </span>
            <span>
              <span className="block text-sm font-semibold text-slate-900">{option.label}</span>
              {option.desc && <span className="mt-0.5 block text-xs text-slate-500">{option.desc}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
};
